module.exports = __webpack_public_path__ + "static/assets/0a2734945bb9bc2ff6451798a13e382c.png";